import _ from 'lodash';

export const formNameException = new Map([
    ['diagTreatInvest', 'Diagnosis, Treatment and Investigations'],
    ['mainScreenSafeguarding', 'Safeguarding'],
    ['rockwood', 'Clinical Frailty Score'],
    ['referrals', 'Specialty Referral'],
    ['paedSafeguarding', 'Paediatric Safeguarding'],
    ['nurseForm', 'Nursing Checklist'],
    ['medicationForm', 'Medical Checklist'],
    ['iceReports', 'Investigations'],
    ['obs', 'Observations'],
    ['icd', 'ICD-10'],
    ['smoking', 'Smoking Status'],
]);

// Get te pretty name of note type
export const formatNoteType = (noteType) => {
    if (noteType) {
        let text = noteType;
        if (noteType.includes('.')) {
            const arr = noteType.split('.');
            text = _.last(arr);
        }
        const exception = formNameException.get(text);
        if (exception) text = exception;

        return _.startCase(text);
    }
};